/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AccountsSearchRequest,
  AccountsSearchResponse,
  AddCampaignMemberResult,
  AssociateChiliUsers,
  CasesSearchRequest,
  CasesSearchResponse,
  ConvertLeadToContactResult,
  ConvertLeadToContactStatuses,
  CountRemoteSalesforceUsers,
  CountRemoteSalesforceUsersResponse,
  DataFieldTypeMetadata,
  DataObjectUrl,
  DescribeDataObjectRequest,
  DuplicateRulesResponse,
  GetByChiliIdsRequest,
  GetByChiliIdsResponse,
  GetUsersRequest,
  GetUsersResponse,
  ImportableSalesforceUserWithDynamicFields,
  LimitedObjectMetadata,
  ListRemoteSalesforceUsers,
  ListTopFieldValues,
  MapString,
  MapTypeListDataFieldMetadata,
  MinimalSalesforceUser,
  MinimalSalesforceUserResponse,
  OauthLocation,
  ObjectMetadataEntry,
  OpportunitiesSearchRequest,
  OpportunitiesSearchResponse,
  OpportunityStagesResponse,
  OpportunityTypesResponse,
  PaginatedResultTCampaignView,
  PaginatedResultTContactView,
  PaginatedResultTLeadView,
  PicklistResponse,
  PublicTenantConfigResponse,
  SFDataObjectWithId,
  SalesforceActionRequestA,
  SalesforceConnection,
  SalesforceConnectionRemovalResponse,
  SimpleAccountId,
  TaskPrioritiesResponse,
  TaskStatusesResponse,
  TaskSubjectsResponse,
  TaskTypesResponse,
  TenantConfigResponse,
} from "./data-contracts";
import { ContentType, FullRequestParams, HttpClient, QueryParamsType, RequestParams } from "../http-client";

export class V1<SecurityDataType = unknown> {
  // See templates/api.ejs we need this in order to send as parameter to request call
  serviceName = "salesforce";
  /**
   * @deprecated Internal use only.
   */
  httpClient: HttpClient<SecurityDataType>;

  constructor(config?: ConstructorParameters<typeof HttpClient<SecurityDataType>>[0]) {
    this.httpClient = new HttpClient(config);
  }

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  request = <T = any, E = any>(params: FullRequestParams): Promise<T> => {
    return this.httpClient.clientRequest<T, E>({ ...params, serviceName: this.serviceName });
  };

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  getServicePath = <Q extends QueryParamsType>(path: string, query?: Q): string => {
    const servicePath = this.httpClient.clientGetPath({ path, serviceName: this.serviceName });

    if (!query) return servicePath;

    const queryParams = this.httpClient.encodeQueryParams(query);
    return `${servicePath}?${queryParams}`;
  };

  /**
   * No description
   *
   * @name CampaignList
   * @request GET:/v1/tenant/{tenantId}/campaigns/list
   * @secure
   */
  campaignList = (
    tenantId: string,
    query?: {
      /** Filter by active status */
      isActive?: boolean;
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 1000
       * @example 1000
       */
      pageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PaginatedResultTCampaignView,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/campaigns/list`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for campaignList */
  campaignListPathGetter = (
    tenantId: string,
    query?: {
      /** Filter by active status */
      isActive?: boolean;
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 1000
       * @example 1000
       */
      pageSize?: number;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/campaigns/list`, query);

  /**
   * No description
   *
   * @name SearchCampaigns
   * @request GET:/v1/tenant/{tenantId}/campaigns/search
   * @secure
   */
  searchCampaigns = (
    tenantId: string,
    query?: {
      /** Filter by active status */
      isActive?: boolean;
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
      /**
       * text to search in all fields of a salesforce object
       * @minLength 2
       * @example "test campaign"
       */
      searchText?: string;
      /**
       *
       * $field(:$order)?
       *
       * available orders: ASC,DESC
       * @example "CreatedDate:DESC"
       */
      orderBy?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PaginatedResultTCampaignView,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/campaigns/search`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for searchCampaigns */
  searchCampaignsPathGetter = (
    tenantId: string,
    query?: {
      /** Filter by active status */
      isActive?: boolean;
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
      /**
       * text to search in all fields of a salesforce object
       * @minLength 2
       * @example "test campaign"
       */
      searchText?: string;
      /**
       *
       * $field(:$order)?
       *
       * available orders: ASC,DESC
       * @example "CreatedDate:DESC"
       */
      orderBy?: string;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/campaigns/search`, query);

  /**
   * @description describes metadata of specified salesforce object
   *
   * @tags Metadata
   * @name DescribeMetadataSalesforceObject
   * @request POST:/v1/tenant/{tenantId}/object/{dataObject}/describe
   * @secure
   */
  describeMetadataSalesforceObject = (
    tenantId: string,
    dataObject: string,
    data: DescribeDataObjectRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      ObjectMetadataEntry,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/object/${dataObject}/describe`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for describeMetadataSalesforceObject */
  describeMetadataSalesforceObjectPathGetter = (tenantId: string, dataObject: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/object/${dataObject}/describe`);

  /**
   * @description describes limited metadata of all salesforce objects
   *
   * @tags Metadata
   * @name DescribeLimitedMetadataOfAllSalesforceObjects
   * @request POST:/v1/tenant/{tenantId}/objects/limited-metadata
   * @secure
   */
  describeLimitedMetadataOfAllSalesforceObjects = (
    tenantId: string,
    data: DescribeDataObjectRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      LimitedObjectMetadata[],
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/objects/limited-metadata`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for describeLimitedMetadataOfAllSalesforceObjects */
  describeLimitedMetadataOfAllSalesforceObjectsPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/objects/limited-metadata`);

  /**
   * @description resolves a DataObject by a salesforce id, returns None if not found
   *
   * @tags Metadata
   * @name ResolveSalesforceObjectById
   * @request POST:/v1/tenant/{tenantId}/objects/resolveById/{id}
   * @secure
   */
  resolveSalesforceObjectById = (
    tenantId: string,
    id: string,
    data: DescribeDataObjectRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      ObjectMetadataEntry,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/objects/resolveById/${id}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for resolveSalesforceObjectById */
  resolveSalesforceObjectByIdPathGetter = (tenantId: string, id: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/objects/resolveById/${id}`);

  /**
   * @description Initiate org-level Salesforce OAuth
   *
   * @tags oauth
   * @name InitiateOrgLevelSalesforceOAuth
   * @request GET:/v1/{tenantId}/oauth/salesforce/initiate
   * @secure
   */
  initiateOrgLevelSalesforceOAuth = (
    tenantId: string,
    query?: {
      isSandbox?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      OauthLocation,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/${tenantId}/oauth/salesforce/initiate`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for initiateOrgLevelSalesforceOAuth */
  initiateOrgLevelSalesforceOAuthPathGetter = (
    tenantId: string,
    query?: {
      isSandbox?: boolean;
    },
  ) => this.getServicePath(`/v1/${tenantId}/oauth/salesforce/initiate`, query);

  /**
   * @description Get org-level Salesforce connection
   *
   * @tags connections
   * @name GetOrgLevelSalesforceConnection
   * @request GET:/v1/{tenantId}/connections/salesforce
   * @secure
   */
  getOrgLevelSalesforceConnection = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      SalesforceConnection,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/${tenantId}/connections/salesforce`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getOrgLevelSalesforceConnection */
  getOrgLevelSalesforceConnectionPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/${tenantId}/connections/salesforce`);

  /**
   * @description Delete org-level Salesforce connection
   *
   * @tags connections
   * @name DeleteOrgLevelSalesforceConnection
   * @request DELETE:/v1/{tenantId}/connections/salesforce
   * @secure
   */
  deleteOrgLevelSalesforceConnection = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      SalesforceConnectionRemovalResponse,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/${tenantId}/connections/salesforce`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for deleteOrgLevelSalesforceConnection */
  deleteOrgLevelSalesforceConnectionPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/${tenantId}/connections/salesforce`);

  /**
   * @description Initiate user-level Salesforce OAuth
   *
   * @tags oauth
   * @name InitiateUserLevelSalesforceOAuth
   * @request GET:/v1/{tenantId}/{userId}/oauth/salesforce/initiate
   * @secure
   */
  initiateUserLevelSalesforceOAuth = (
    tenantId: string,
    userId: string,
    query?: {
      isSandbox?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      OauthLocation,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/${tenantId}/${userId}/oauth/salesforce/initiate`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for initiateUserLevelSalesforceOAuth */
  initiateUserLevelSalesforceOAuthPathGetter = (
    tenantId: string,
    userId: string,
    query?: {
      isSandbox?: boolean;
    },
  ) => this.getServicePath(`/v1/${tenantId}/${userId}/oauth/salesforce/initiate`, query);

  /**
   * @description Get user-level Salesforce connection
   *
   * @tags connections
   * @name GetUserLevelSalesforceConnection
   * @request GET:/v1/{tenantId}/{userId}/connections/salesforce
   * @secure
   */
  getUserLevelSalesforceConnection = (tenantId: string, userId: string, params: RequestParams = {}) =>
    this.request<
      SalesforceConnection,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/${tenantId}/${userId}/connections/salesforce`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getUserLevelSalesforceConnection */
  getUserLevelSalesforceConnectionPathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v1/${tenantId}/${userId}/connections/salesforce`);

  /**
   * @description Delete user-level Salesforce connection
   *
   * @tags connections
   * @name DeleteUserLevelSalesforceConnection
   * @request DELETE:/v1/{tenantId}/{userId}/connections/salesforce
   * @secure
   */
  deleteUserLevelSalesforceConnection = (tenantId: string, userId: string, params: RequestParams = {}) =>
    this.request<
      SalesforceConnectionRemovalResponse,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/${tenantId}/${userId}/connections/salesforce`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for deleteUserLevelSalesforceConnection */
  deleteUserLevelSalesforceConnectionPathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v1/${tenantId}/${userId}/connections/salesforce`);

  /**
   * @description Complete Salesforce OAuth
   *
   * @tags oauth
   * @name CompleteSalesforceOAuth
   * @request GET:/v1/public/oauth/callback
   */
  completeSalesforceOAuth = (
    query: {
      /** @minLength 1 */
      code?: string;
      /** @minLength 1 */
      error?: string;
      /** @minLength 1 */
      state: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      any,
      | void
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
        }
    >({
      path: `/v1/public/oauth/callback`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @description Returns string containing request path for completeSalesforceOAuth */
  completeSalesforceOAuthPathGetter = (query: {
    /** @minLength 1 */
    code?: string;
    /** @minLength 1 */
    error?: string;
    /** @minLength 1 */
    state: string;
  }) => this.getServicePath(`/v1/public/oauth/callback`, query);

  /**
   * @description get generic by id
   *
   * @tags Generic / Authorized
   * @name GetGenericByIdForUsers
   * @request GET:/v1/{tenantId}/generic/object/{dataObject}/id/{id}
   * @secure
   */
  getGenericByIdForUsers = (
    tenantId: string,
    dataObject: string,
    id: string,
    query?: {
      /**
       * csv list of fields to return from the queried objects - not specified will return ALL fields
       * @minItems 1
       * @example "Id,Email,OwnerId"
       */
      fieldsToReturn?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      SFDataObjectWithId,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/${tenantId}/generic/object/${dataObject}/id/${id}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getGenericByIdForUsers */
  getGenericByIdForUsersPathGetter = (
    tenantId: string,
    dataObject: string,
    id: string,
    query?: {
      /**
       * csv list of fields to return from the queried objects - not specified will return ALL fields
       * @minItems 1
       * @example "Id,Email,OwnerId"
       */
      fieldsToReturn?: string;
    },
  ) => this.getServicePath(`/v1/${tenantId}/generic/object/${dataObject}/id/${id}`, query);

  /**
   * No description
   *
   * @name ObjectUrl
   * @request GET:/v1/tenant/{tenantId}/object-url/{id}
   * @secure
   */
  objectUrl = (tenantId: string, id: string, params: RequestParams = {}) =>
    this.request<
      DataObjectUrl,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/object-url/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for objectUrl */
  objectUrlPathGetter = (tenantId: string, id: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/object-url/${id}`);

  /**
   * @description list User record fields
   *
   * @tags User Import
   * @name ListUserRecordFields
   * @request GET:/v1/import/{tenantId}/user-fields/values
   * @secure
   */
  listUserRecordFields = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      MapTypeListDataFieldMetadata,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/import/${tenantId}/user-fields/values`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listUserRecordFields */
  listUserRecordFieldsPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/import/${tenantId}/user-fields/values`);

  /**
   * @description list User record fields operators
   *
   * @tags User Import
   * @name ListUserRecordFieldsOperators
   * @request GET:/v1/import/{tenantId}/user-fields/operators
   * @secure
   */
  listUserRecordFieldsOperators = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      DataFieldTypeMetadata[],
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/import/${tenantId}/user-fields/operators`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listUserRecordFieldsOperators */
  listUserRecordFieldsOperatorsPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/import/${tenantId}/user-fields/operators`);

  /**
   * @description list top values per field (count-wise, descending by number of occurrences)
   *
   * @tags User Import
   * @name ListTopValuesPerField
   * @request POST:/v1/import/{tenantId}/user-fields/top-values
   * @secure
   */
  listTopValuesPerField = (tenantId: string, data: ListTopFieldValues, params: RequestParams = {}) =>
    this.request<
      any[],
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/import/${tenantId}/user-fields/top-values`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listTopValuesPerField */
  listTopValuesPerFieldPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/import/${tenantId}/user-fields/top-values`);

  /**
   * @description list users
   *
   * @tags User Import
   * @name ListUsers
   * @request POST:/v1/import/{tenantId}/users
   * @secure
   */
  listUsers = (tenantId: string, data: ListRemoteSalesforceUsers, params: RequestParams = {}) =>
    this.request<
      ImportableSalesforceUserWithDynamicFields[],
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/import/${tenantId}/users`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listUsers */
  listUsersPathGetter = (tenantId: string) => this.getServicePath(`/v1/import/${tenantId}/users`);

  /**
   * @description count users
   *
   * @tags User Import
   * @name CountUsers
   * @request POST:/v1/import/{tenantId}/count-users
   * @secure
   */
  countUsers = (tenantId: string, data: CountRemoteSalesforceUsers, params: RequestParams = {}) =>
    this.request<
      CountRemoteSalesforceUsersResponse,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/import/${tenantId}/count-users`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for countUsers */
  countUsersPathGetter = (tenantId: string) => this.getServicePath(`/v1/import/${tenantId}/count-users`);

  /**
   * @description Remaps chili users to salesforce users. Input is a list of (chili id, sf email, sf id), so the client has to correctly construct these values by e.g. obtaining a list of existing mappings via the 'by-chili-ids' endpoint. For each record in the argument list, the system will find all records with either chili or saleseforce id and delete it, and then will insert provided values.
   *
   * @tags User Import
   * @name RemapUsers
   * @request POST:/v1/user-management/{tenantId}/associate
   * @secure
   */
  remapUsers = (tenantId: string, data: AssociateChiliUsers, params: RequestParams = {}) =>
    this.request<
      void,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/user-management/${tenantId}/associate`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for remapUsers */
  remapUsersPathGetter = (tenantId: string) => this.getServicePath(`/v1/user-management/${tenantId}/associate`);

  /**
   * @description Get user mapping given chili ids. Returns a map of chili ids to (optional) salesforce user representation in our system, which is (chili id, sf email, sf id)
   *
   * @tags User Import
   * @name GetUsersByChiliIds
   * @request POST:/v1/user-management/{tenantId}/find/by-chili-ids
   * @secure
   */
  getUsersByChiliIds = (tenantId: string, data: GetByChiliIdsRequest, params: RequestParams = {}) =>
    this.request<
      GetByChiliIdsResponse,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/user-management/${tenantId}/find/by-chili-ids`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getUsersByChiliIds */
  getUsersByChiliIdsPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/user-management/${tenantId}/find/by-chili-ids`);

  /**
   * @description [Deprecated] - use get users instead
   *
   * @tags User
   * @name GetUser
   * @request GET:/v1/tenant/{tenantId}/user/{userId}
   * @deprecated
   */
  getUser = (tenantId: string, userId: string, params: RequestParams = {}) =>
    this.request<
      MinimalSalesforceUserResponse,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user/${userId}`,
      method: "GET",
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getUser */
  getUserPathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/user/${userId}`);

  /**
   * @description get multiple users by user ids
   *
   * @tags User
   * @name GetUsers
   * @request POST:/v1/tenant/{tenantId}/users/batch
   */
  getUsers = (tenantId: string, data: GetUsersRequest, params: RequestParams = {}) =>
    this.request<
      GetUsersResponse,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/users/batch`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getUsers */
  getUsersPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/users/batch`);

  /**
   * @description get user by salesforce id
   *
   * @tags User
   * @name GetUserBySalesforceId
   * @request GET:/v1/tenant/{tenantId}/salesforce-user/{salesforceUserId}
   */
  getUserBySalesforceId = (tenantId: string, salesforceUserId: string, params: RequestParams = {}) =>
    this.request<
      MinimalSalesforceUserResponse,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/salesforce-user/${salesforceUserId}`,
      method: "GET",
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getUserBySalesforceId */
  getUserBySalesforceIdPathGetter = (tenantId: string, salesforceUserId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/salesforce-user/${salesforceUserId}`);

  /**
   * @description get users by salesforce IDs
   *
   * @tags User
   * @name GetUsersBySalesforceIDs
   * @request GET:/v1/tenant/{tenantId}/salesforce-user
   */
  getUsersBySalesforceIDs = (
    tenantId: string,
    query?: {
      sfid?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      MinimalSalesforceUser[],
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/salesforce-user`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getUsersBySalesforceIDs */
  getUsersBySalesforceIDsPathGetter = (
    tenantId: string,
    query?: {
      sfid?: string[];
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/salesforce-user`, query);

  /**
   * @description Get fire tenant configuration
   *
   * @name GetFireTenantConfiguration
   * @request GET:/v1/tenant/{tenantId}/config
   * @secure
   */
  getFireTenantConfiguration = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      TenantConfigResponse,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/config`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getFireTenantConfiguration */
  getFireTenantConfigurationPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/config`);

  /**
   * @description Get fire tenant configuration (public)
   *
   * @tags public salesforce tenant config
   * @name GetFireTenantConfigurationPublic
   * @request GET:/v1/public/tenant/{tenantId}/config
   */
  getFireTenantConfigurationPublic = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      PublicTenantConfigResponse,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/public/tenant/${tenantId}/config`,
      method: "GET",
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getFireTenantConfigurationPublic */
  getFireTenantConfigurationPublicPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/public/tenant/${tenantId}/config`);

  /**
   * No description
   *
   * @name PicklistForACampaignStatus
   * @request GET:/v1/tenant/{tenantId}/picklist/campaign
   * @secure
   */
  picklistForACampaignStatus = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      PicklistResponse,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/picklist/campaign`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for picklistForACampaignStatus */
  picklistForACampaignStatusPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/picklist/campaign`);

  /**
   * No description
   *
   * @name PicklistForACampaignMemberStatus
   * @request GET:/v1/tenant/{tenantId}/picklist/campaign-member/{campaignId}
   * @secure
   */
  picklistForACampaignMemberStatus = (tenantId: string, campaignId: string, params: RequestParams = {}) =>
    this.request<
      PicklistResponse,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/picklist/campaign-member/${campaignId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for picklistForACampaignMemberStatus */
  picklistForACampaignMemberStatusPathGetter = (tenantId: string, campaignId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/picklist/campaign-member/${campaignId}`);

  /**
   * @description attempts to convert lead to contact based on specified params
   *
   * @tags Actions
   * @name ConvertLeadToContact
   * @request POST:/v1/tenant/{tenantId}/actions/convert-lead-to-contact
   */
  convertLeadToContact = (tenantId: string, data: SalesforceActionRequestA, params: RequestParams = {}) =>
    this.request<
      ConvertLeadToContactResult,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/actions/convert-lead-to-contact`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for convertLeadToContact */
  convertLeadToContactPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/actions/convert-lead-to-contact`);

  /**
   * @description fetch the possible statuses for lead to contact conversion
   *
   * @tags Actions
   * @name ConvertLeadToContactStatuses
   * @request GET:/v1/tenant/{tenantId}/actions/convert-lead-to-contact/statuses
   */
  convertLeadToContactStatuses = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      ConvertLeadToContactStatuses,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/actions/convert-lead-to-contact/statuses`,
      method: "GET",
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for convertLeadToContactStatuses */
  convertLeadToContactStatusesPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/actions/convert-lead-to-contact/statuses`);

  /**
   * @description attempts to add campaign member object to salesforce
   *
   * @tags Actions
   * @name AddCampaignMemberAction
   * @request POST:/v1/tenant/{tenantId}/actions/add-campaign-member
   */
  addCampaignMemberAction = (tenantId: string, data: SalesforceActionRequestA, params: RequestParams = {}) =>
    this.request<
      AddCampaignMemberResult,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/actions/add-campaign-member`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for addCampaignMemberAction */
  addCampaignMemberActionPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/actions/add-campaign-member`);

  /**
   * No description
   *
   * @name ListTaskStatuses
   * @request GET:/v1/tenant/{tenantId}/tasks/statuses
   * @secure
   */
  listTaskStatuses = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      TaskStatusesResponse,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/tasks/statuses`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listTaskStatuses */
  listTaskStatusesPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/tasks/statuses`);

  /**
   * No description
   *
   * @name ListTaskPriorities
   * @request GET:/v1/tenant/{tenantId}/tasks/priorities
   * @secure
   */
  listTaskPriorities = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      TaskPrioritiesResponse,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/tasks/priorities`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listTaskPriorities */
  listTaskPrioritiesPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/tasks/priorities`);

  /**
   * No description
   *
   * @name ListTaskTypes
   * @request GET:/v1/tenant/{tenantId}/tasks/types
   * @secure
   */
  listTaskTypes = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      TaskTypesResponse,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/tasks/types`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listTaskTypes */
  listTaskTypesPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/tasks/types`);

  /**
   * No description
   *
   * @name ListTaskSubjects
   * @request GET:/v1/tenant/{tenantId}/tasks/subjects
   * @secure
   */
  listTaskSubjects = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      TaskSubjectsResponse,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/tasks/subjects`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listTaskSubjects */
  listTaskSubjectsPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/tasks/subjects`);

  /**
   * No description
   *
   * @tags Matching
   * @name ListDuplicateRulesForTenant
   * @request GET:/v1/tenant/{tenantId}/duplicate-rules
   * @secure
   */
  listDuplicateRulesForTenant = (
    tenantId: string,
    query?: {
      /**
       * salesforce data objects to query for
       * @minItems 1
       * @example ["Contact","Case","Lead"]
       */
      dataObjects?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      DuplicateRulesResponse,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/duplicate-rules`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listDuplicateRulesForTenant */
  listDuplicateRulesForTenantPathGetter = (
    tenantId: string,
    query?: {
      /**
       * salesforce data objects to query for
       * @minItems 1
       * @example ["Contact","Case","Lead"]
       */
      dataObjects?: string[];
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/duplicate-rules`, query);

  /**
   * No description
   *
   * @name ListOpportunityStages
   * @request GET:/v1/tenant/{tenantId}/opportunities/stages
   * @secure
   */
  listOpportunityStages = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      OpportunityStagesResponse,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/opportunities/stages`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listOpportunityStages */
  listOpportunityStagesPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/opportunities/stages`);

  /**
   * No description
   *
   * @name ListOpportunityTypes
   * @request GET:/v1/tenant/{tenantId}/opportunities/types
   * @secure
   */
  listOpportunityTypes = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      OpportunityTypesResponse,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/opportunities/types`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listOpportunityTypes */
  listOpportunityTypesPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/opportunities/types`);

  /**
   * No description
   *
   * @name SearchOpportunities
   * @request POST:/v1/tenant/{tenantId}/opportunities/search
   * @secure
   */
  searchOpportunities = (tenantId: string, data: OpportunitiesSearchRequest, params: RequestParams = {}) =>
    this.request<
      OpportunitiesSearchResponse,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/opportunities/search`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for searchOpportunities */
  searchOpportunitiesPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/opportunities/search`);

  /**
   * No description
   *
   * @name SearchAccounts
   * @request POST:/v1/tenant/{tenantId}/accounts/search
   * @secure
   */
  searchAccounts = (tenantId: string, data: AccountsSearchRequest, params: RequestParams = {}) =>
    this.request<
      AccountsSearchResponse,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/accounts/search`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for searchAccounts */
  searchAccountsPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/accounts/search`);

  /**
   * @description This endpoint is deprecated and will be removed in the future. Use /api/v2/tenant/$id/customer/account instead.
   *
   * @name SearchAccountsFromCpPoinOfView
   * @request POST:/v1/tenant/{tenantId}/accountsFromChiliPiperPointOfView/search
   * @deprecated
   * @secure
   */
  searchAccountsFromCpPoinOfView = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      SimpleAccountId,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/accountsFromChiliPiperPointOfView/search`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for searchAccountsFromCpPoinOfView */
  searchAccountsFromCpPoinOfViewPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/accountsFromChiliPiperPointOfView/search`);

  /**
   * No description
   *
   * @name SearchCases
   * @request POST:/v1/tenant/{tenantId}/cases/search
   * @secure
   */
  searchCases = (tenantId: string, data: CasesSearchRequest, params: RequestParams = {}) =>
    this.request<
      CasesSearchResponse,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/cases/search`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for searchCases */
  searchCasesPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/cases/search`);

  /**
   * No description
   *
   * @name SearchContacts
   * @request GET:/v1/tenant/{tenantId}/contacts/search
   * @secure
   */
  searchContacts = (
    tenantId: string,
    query?: {
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
      /**
       * text to search in all fields of a salesforce object
       * @minLength 2
       * @example "test campaign"
       */
      searchText?: string;
      /**
       *
       * $field(:$order)?
       *
       * available orders: ASC,DESC
       * @example "CreatedDate:DESC"
       */
      orderBy?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PaginatedResultTContactView,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/contacts/search`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for searchContacts */
  searchContactsPathGetter = (
    tenantId: string,
    query?: {
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
      /**
       * text to search in all fields of a salesforce object
       * @minLength 2
       * @example "test campaign"
       */
      searchText?: string;
      /**
       *
       * $field(:$order)?
       *
       * available orders: ASC,DESC
       * @example "CreatedDate:DESC"
       */
      orderBy?: string;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/contacts/search`, query);

  /**
   * No description
   *
   * @name SearchLeads
   * @request GET:/v1/tenant/{tenantId}/leads/search
   * @secure
   */
  searchLeads = (
    tenantId: string,
    query?: {
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
      /**
       * text to search in all fields of a salesforce object
       * @minLength 2
       * @example "test campaign"
       */
      searchText?: string;
      /**
       *
       * $field(:$order)?
       *
       * available orders: ASC,DESC
       * @example "CreatedDate:DESC"
       */
      orderBy?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PaginatedResultTLeadView,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/leads/search`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for searchLeads */
  searchLeadsPathGetter = (
    tenantId: string,
    query?: {
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
      /**
       * text to search in all fields of a salesforce object
       * @minLength 2
       * @example "test campaign"
       */
      searchText?: string;
      /**
       *
       * $field(:$order)?
       *
       * available orders: ASC,DESC
       * @example "CreatedDate:DESC"
       */
      orderBy?: string;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/leads/search`, query);

  /**
   * No description
   *
   * @name InternalRemoveAllDataForATenant
   * @request DELETE:/v1/tenant/{tenantId}/backoffice/remove-all-data
   */
  internalRemoveAllDataForATenant = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      void,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/backoffice/remove-all-data`,
      method: "DELETE",
      ...params,
    });

  /**
   * @description Returns string containing request path for internalRemoveAllDataForATenant */
  internalRemoveAllDataForATenantPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/backoffice/remove-all-data`);
}
